import { APP_HEADER_HEIGHT, APP_HEADER_HEIGHT_MOBILE, mediaQuery } from 'constants/ui';

// Dark: a dark app-surface top bar with a subtle bottom border (per the dark design handoff),
// instead of the brand-colored header used in light. Light keeps the tenant-branded header.
const getHeaderBackground = palette =>
  palette.mode === 'dark' ? palette.background.primary : palette.primary.main;

export const headerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '30px',
  position: 'relative',
  height: `${APP_HEADER_HEIGHT}px`,
  padding: '0 33px',
  backgroundColor: ({ palette }) => getHeaderBackground(palette),
  borderBottom: ({ palette }) =>
    palette.mode === 'dark' ? `1px solid ${palette.border.default}` : 'none',
  zIndex: 1250,

  [mediaQuery.mobileAndTablet]: {
    height: `${APP_HEADER_HEIGHT_MOBILE}px`,
    gap: '12px',
    padding: '0 12px',
  },

  '&.backdrop': {
    zIndex: 0,
  },
};

export const iconButtonStyles = {
  svg: {
    path: {
      fill: '#FFF',
    },
  },
};

export const headerActionsStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '30px',
  marginLeft: 'auto',
  flexShrink: 0,

  [mediaQuery.mobileAndTablet]: {
    gap: '12px',
  },
};
